import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Nav } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import Modal from "react-bootstrap/Modal";

import { Collapse, Navbar, Container } from "reactstrap";
import useFetchUserData from "hooks/useAuthUserData";
import routes from "routes.js";
import { Dropdown } from "react-bootstrap";
import Loader from "utils/loader";
import useFetchUserStats from "hooks/useFetchUserStats";
import { toast } from "react-toastify";
import useAuth from "hooks/useAuth";
import { useWeb3React } from "@web3-react/core";
import { setupNetwork } from "utils/wallet";

function Header(props) {
  const { account } = useWeb3React();
  console.log(account, "acccoumttttt");

  const { login, logout } = useAuth();
  const token = localStorage?.getItem("authToken");

  const useData = useFetchUserData();
  const user = useData?.data?.data;
  console.log("USERS DATA :", user);
  // console.log(user);
  const userDashboardStats = useFetchUserStats();
  console.log(userDashboardStats);

  const history = useHistory();

  const [isOpen, setIsOpen] = React.useState(false);
  const [brandName, setbrandName] = React.useState();
  const [color, setColor] = React.useState("transparent");
  const sidebarToggle = React.useRef();
  const location = useLocation();

  const toggle = () => {
    if (isOpen) {
      setColor("transparent");
    } else {
      setColor("");
    }
    setIsOpen(!isOpen);
  };

  const getBrand = () => {
    routes.map((prop, key) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        setbrandName(prop.name);
      }
      return null;
    });
  };

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      history.push("/");
      return;
    }
  }, [history]);

  // useEffect(() => {
  //   if()
  // },[user,useData])

  useEffect(() => {
    getBrand();
  });

  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
  };
  const updateColor = () => {
    if (window.innerWidth < 993 && isOpen) {
      setColor("");
    } else {
      setColor("transparent");
    }
  };

  React.useEffect(() => {
    window.addEventListener("resize", updateColor.bind(this));
  });

  React.useEffect(() => {
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      sidebarToggle.current.classList.toggle("toggled");
    }
  }, [location]);

  const [showdis, setShowdis] = useState(false);
  const handleClosedis = () => setShowdis(false);

  const [activeTab, setActiveTab] = useState("link-1");

  const handleSelect = (selectedTab) => {
    setActiveTab(selectedTab);
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show10, setShow10] = useState(false);

  const handleClose10 = () => setShow10(false);
  const handleShow10 = () => setShow10(true);

  const [show9, setShow9] = useState(false);

  const handleClose9 = () => setShow9(false);
  const handleShow9 = () => setShow9(true);

  const [show8, setShow8] = useState(false);

  const handleClose8 = () => setShow8(false);
  const handleShow8 = () => setShow8(true);

  const [show7, setShow7] = useState(false);

  const handleClose7 = () => setShow7(false);
  const handleShow7 = () => setShow7(true);

  const [show6, setShow6] = useState(false);

  const handleClose6 = () => setShow6(false);
  const handleShow6 = () => setShow6(true);

  const [show3, setShow3] = useState(false);

  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);

  const [show4, setShow4] = useState(false);

  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);

  const [show5, setShow5] = useState(false);

  const handleClose5 = () => setShow5(false);
  const handleShow5 = () => setShow5(true);

  const [show1, setShow1] = useState(false);

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);

  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const connectMetaMask1 = async () => {
    if (account) {
      const connectorId = window.localStorage.getItem("connectorId");
      await logout(connectorId);
      localStorage.removeItem("connectorId");
      localStorage.removeItem("flag");
    } else {
      let res = await setupNetwork();
      console.log(res, "res in setupNetwork");

      if (res) {
        login("injected");
        localStorage.setItem("connectorId", "injected");
        localStorage.setItem("flag", "true");
        handleClose();
      }
    }
  };

  const trustWallet = async () => {
    if (account) {
      await logout("walletconnect");
      localStorage.clear();
      handleClose();
    } else {
      try {
        handleClose();
        login("walletconnect");
        localStorage.setItem("connectorId", "walletconnect");
        localStorage.setItem("flag", "true");
      } catch (err) {
        console.log("eerr", err);
      }
    }
  };

  const logoutHandle = async () => {
    if (account) {
      console.log("account in logout click", account);
      const connectorId = window.localStorage.getItem("connectorId");
      await logout(connectorId);
      localStorage.removeItem("connectorId");
      localStorage.removeItem("flag");
    } else {
      window.location.reload();
    }
  };

  const logoutUserHandle = () => {
    localStorage?.removeItem("authToken");
    localStorage?.removeItem("referalAddress");
    window?.location?.reload();
  };

  return (
    <>
      {brandName === "Product Details" ||
      brandName === "Edit Product Details" ||
      brandName === "Create Project" ? (
        <div className="main-navbar">
          <Navbar
            color={
              props.location.pathname.indexOf("full-screen-maps") !== -1
                ? ""
                : color
            }
            expand="lg"
            className={
              props.location.pathname.indexOf("full-screen-maps") !== -1
                ? ""
                : "" + (color === "transparent" ? "navbar-transparent " : "")
            }
          >
            <Container fluid className="main-header-top-change p-0">
              <div className="topnavbar d-none">
                <div className="logo d-none mobile-show-logo">
                  <img src="\logo.svg" alt="img" className="img-fluid" />
                </div>
                <div className="navbar-wrapper">
                  <Dropdown align="end">
                    <Dropdown.Toggle
                      className="notificationbtn"
                      id="dropdown-basic"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12.0201 2.90997C8.71009 2.90997 6.02009 5.59997 6.02009 8.90997V11.8C6.02009 12.41 5.76009 13.34 5.45009 13.86L4.30009 15.77C3.59009 16.95 4.08009 18.26 5.38009 18.7C9.69009 20.14 14.3401 20.14 18.6501 18.7C19.8601 18.3 20.3901 16.87 19.7301 15.77L18.5801 13.86C18.2801 13.34 18.0201 12.41 18.0201 11.8V8.90997C18.0201 5.60997 15.3201 2.90997 12.0201 2.90997Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                        />
                        <path
                          d="M13.8699 3.2C13.5599 3.11 13.2399 3.04 12.9099 3C11.9499 2.88 11.0299 2.95 10.1699 3.2C10.4599 2.46 11.1799 1.94 12.0199 1.94C12.8599 1.94 13.5799 2.46 13.8699 3.2Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.02 19.06C15.02 20.71 13.67 22.06 12.02 22.06C11.2 22.06 10.44 21.72 9.90002 21.18C9.36002 20.64 9.02002 19.88 9.02002 19.06"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                        />
                      </svg>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="recentdivv">
                      <div className="topdiv">
                        <h5>Notifications</h5>
                        <p className="markpara">Mark all as read</p>
                      </div>
                      <div className="outerborder">
                        <div className="innercard">
                          <div className="circlemain">
                            <img
                              src="\assets\dashboard\Add_Plus.svg"
                              className="circlesss"
                              alt="img"
                            />
                          </div>
                          <div className="innercardtexts">
                            <h4>
                              Added new product{" "}
                              <span>Professional Coffee Maker WF-256</span>
                            </h4>
                            <div className="datamain">
                              <span className="datecircle"></span>
                              <p className="datepara">June 12, 2024 14:56</p>
                            </div>
                          </div>
                        </div>
                        <div className="innercard">
                          <div className="circlemain">
                            <img
                              src="\assets\dashboard\Add_Plus1.svg"
                              className="circlesss"
                              alt="img"
                            />
                          </div>
                          <div className="innercardtexts">
                            <h4>
                              Added new product{" "}
                              <span>Professional Coffee Maker WF-256</span>
                            </h4>
                            <div className="datamain">
                              <span className="datecircle"></span>
                              <p className="datepara">June 12, 2024 14:56</p>
                            </div>
                          </div>
                        </div>
                        <div className="innercard">
                          <div className="circlemain">
                            <img
                              src="\assets\dashboard\Add_Plus2.svg"
                              className="circlesss"
                              alt="img"
                            />
                          </div>
                          <div className="innercardtexts">
                            <h4>
                              Added new product{" "}
                              <span>Professional Coffee Maker WF-256</span>
                            </h4>
                            <div className="datamain">
                              <span className="datecircle"></span>
                              <p className="datepara">June 12, 2024 14:56</p>
                            </div>
                          </div>
                        </div>
                        <div className="innercard">
                          <div className="circlemain">
                            <img
                              src="\assets\dashboard\Add_Plus.svg"
                              className="circlesss"
                              alt="img"
                            />
                          </div>
                          <div className="innercardtexts">
                            <h4>
                              Added new product{" "}
                              <span>Professional Coffee Maker WF-256</span>
                            </h4>
                            <div className="datamain">
                              <span className="datecircle"></span>
                              <p className="datepara">June 12, 2024 14:56</p>
                            </div>
                          </div>
                        </div>
                        <div className="innercard">
                          <div className="circlemain">
                            <img
                              src="\assets\dashboard\Add_Plus1.svg"
                              className="circlesss"
                              alt="img"
                            />
                          </div>
                          <div className="innercardtexts">
                            <h4>
                              Added new product{" "}
                              <span>Professional Coffee Maker WF-256</span>
                            </h4>
                            <div className="datamain">
                              <span className="datecircle"></span>
                              <p className="datepara">June 12, 2024 14:56</p>
                            </div>
                          </div>
                        </div>
                        <div className="innercard">
                          <div className="circlemain">
                            <img
                              src="\assets\dashboard\Add_Plus.svg"
                              className="circlesss"
                              alt="img"
                            />
                          </div>
                          <div className="innercardtexts">
                            <h4>
                              Added new product{" "}
                              <span>Professional Coffee Maker WF-256</span>
                            </h4>
                            <div className="datamain">
                              <span className="datecircle"></span>
                              <p className="datepara">June 12, 2024 14:56</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                  <div className="navbar-toggle">
                    <button
                      type="button"
                      ref={sidebarToggle}
                      className="notificationbtn"
                      onClick={() => openSidebar()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="23"
                        viewBox="0 0 22 23"
                        fill="none"
                      >
                        <path
                          d="M4.5835 16.0834H11.9168M4.5835 11.5H17.4168M10.0835 6.91669H17.4168"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {/* <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" /> */}
                    </button>
                  </div>
                  {/* <NavbarBrand href="/">{brandName}</NavbarBrand> */}
                </div>
              </div>
              {/* <NavbarToggler onClick={toggle}>
        <span className="navbar-toggler-bar navbar-kebab" />
        <span className="navbar-toggler-bar navbar-kebab" />
        <span className="navbar-toggler-bar navbar-kebab" />
      </NavbarToggler> */}
              <div className="innnernavbar  newnavbar">
                <div className="newnavleft">
                  {brandName === "Edit Product Details" ? (
                    <Link to="/user/productdetail" className="backbtn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M11.6666 13.3332L8.33325 9.99984L11.6666 6.6665"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Link>
                  ) : (
                    <Link to="/user/myproducts" className="backbtn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M11.6666 13.3332L8.33325 9.99984L11.6666 6.6665"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Link>
                  )}
                  {/* <Link to="/user/myproducts" className="backbtn"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M11.6666 13.3332L8.33325 9.99984L11.6666 6.6665" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg></Link> */}
                  <p className="mainbrandnamepara">
                    {brandName}
                    {brandName === "Purchased NFTs" &&
                      `(${userDashboardStats?.nftCount})`}
                  </p>
                </div>
                {brandName === "Edit Product Details" ? (
                  <div className="newnavright displaynoneformobile">
                    <button onClick={handleShow2} className="savebtn">
                      Save Changes
                    </button>
                    <Link to="/user/productdetail" className="editbtn">
                      Cancel
                    </Link>
                  </div>
                ) : (
                  <div className="newnavright">
                    {brandName === "Create Project" ? (
                      <>
                        <div className="navright">
                          <div className="inputdiv">
                            <input
                              type="text"
                              id="fname"
                              name="fname"
                              className="inputnavvv"
                              placeholder="Search "
                            />
                            {/* <img className='imgwhitesearch' src='\assets\Searchwhite.svg' alt='search' /> */}

                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              className="imgwhitesearch"
                            >
                              <path
                                d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z"
                                stroke="#7E7E7E"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M15.75 15.7498L12.4875 12.4873"
                                stroke="#7E7E7E"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                          <button className="navcommonbtn" onClick={handleShow}>
                            Connect Wallet
                          </button>
                          <button className="whitebtn" onClick={handleShow}>
                            <div className="whitebtnimg">
                              <img
                                src="/assets/dummyassets/user.svg"
                                alt="btninnerimg"
                                className="btninnerimg"
                              />
                            </div>
                            <p className="btninnerpara">
                              {user
                                ? user.name
                                  ? user?.name
                                  : user?.email.split("@")[0]
                                : ""}
                            </p>
                          </button>
                        </div>
                      </>
                    ) : (
                      <Link to="/user/editproduct" className="editbtn">
                        Edit Product
                      </Link>
                    )}
                  </div>
                )}
              </div>
            </Container>
          </Navbar>
        </div>
      ) : (
        <>
          {brandName === "Product Detail" || brandName === "Edit History" ? (
            <div className="main-navbar">
              <Navbar
                color={
                  props.location.pathname.indexOf("full-screen-maps") !== -1
                    ? ""
                    : color
                }
                expand="lg"
                className={
                  props.location.pathname.indexOf("full-screen-maps") !== -1
                    ? ""
                    : "" +
                      (color === "transparent" ? "navbar-transparent " : "")
                }
              >
                <Container fluid className="main-header-top-change p-0">
                  <div className="topnavbar d-none">
                    <div className="logo d-none mobile-show-logo">
                      <img src="\logo.svg" alt="img" className="img-fluid" />
                    </div>
                    <div className="navbar-wrapper">
                      <div className="navbar-toggle">
                        <button
                          type="button"
                          ref={sidebarToggle}
                          className="notificationbtn"
                          onClick={() => openSidebar()}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="23"
                            viewBox="0 0 22 23"
                            fill="none"
                          >
                            <path
                              d="M4.5835 16.0834H11.9168M4.5835 11.5H17.4168M10.0835 6.91669H17.4168"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          {/* <span className="navbar-toggler-bar bar1" />
               <span className="navbar-toggler-bar bar2" />
               <span className="navbar-toggler-bar bar3" /> */}
                        </button>
                      </div>
                      {/* <NavbarBrand href="/">{brandName}</NavbarBrand> */}
                    </div>
                  </div>
                  {/* <NavbarToggler onClick={toggle}>
           <span className="navbar-toggler-bar navbar-kebab" />
           <span className="navbar-toggler-bar navbar-kebab" />
           <span className="navbar-toggler-bar navbar-kebab" />
         </NavbarToggler> */}
                  <div className="innnernavbar  newnavbar">
                    <div className="newnavleft">
                      {brandName === "Product Detail" ? (
                        <Link to="/user/verifynewproducts" className="backbtn">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M11.6666 13.3332L8.33325 9.99984L11.6666 6.6665"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Link>
                      ) : (
                        <Link to="/user/verifyproductedit" className="backbtn">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M11.6666 13.3332L8.33325 9.99984L11.6666 6.6665"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Link>
                      )}
                      {/* <Link to="/user/myproducts" className="backbtn"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M11.6666 13.3332L8.33325 9.99984L11.6666 6.6665" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg></Link> */}
                      <p className="mainbrandnamepara">
                        {brandName}
                        {brandName === "Purchased NFTs" &&
                          `(${userDashboardStats?.nftCount})`}
                      </p>
                    </div>
                    <div className="newnavright displaynoneformobile">
                      <div className="buttonshaed">
                        <button className="cmntbutton">Add Comments</button>
                        <div>
                          <Dropdown className="detaildropdown">
                            <Dropdown.Toggle
                              variant="success"
                              id="dropdown-basic"
                            >
                              Select Option
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="9"
                                height="6"
                                viewBox="0 0 9 6"
                                fill="none"
                              >
                                <path
                                  d="M8.35638 0.5H4.64822H1.30909C0.737686 0.5 0.451986 1.25891 0.856729 1.70379L3.93992 5.09274C4.43394 5.63575 5.23748 5.63575 5.7315 5.09274L6.90406 3.80389L8.81469 1.70379C9.21348 1.25891 8.92778 0.5 8.35638 0.5Z"
                                  fill="black"
                                />
                              </svg>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item
                                href="#/action-1"
                                onClick={handleShow3}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                >
                                  <path
                                    d="M9 16.5C13.125 16.5 16.5 13.125 16.5 9C16.5 4.875 13.125 1.5 9 1.5C4.875 1.5 1.5 4.875 1.5 9C1.5 13.125 4.875 16.5 9 16.5Z"
                                    stroke="#22C154"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M5.8125 8.99994L7.935 11.1224L12.1875 6.87744"
                                    stroke="#22C154"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>{" "}
                                Approve
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="#/action-2"
                                onClick={handleShow5}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                >
                                  <path
                                    d="M9.94452 2.69992L3.78702 9.21742C3.55452 9.46492 3.32952 9.95242 3.28452 10.2899L3.00702 12.7199C2.90952 13.5974 3.53952 14.1974 4.40952 14.0474L6.82452 13.6349C7.16202 13.5749 7.63452 13.3274 7.86702 13.0724L14.0245 6.55492C15.0895 5.42992 15.5695 4.14742 13.912 2.57992C12.262 1.02742 11.0095 1.57492 9.94452 2.69992Z"
                                    stroke="#FBBC05"
                                    stroke-width="1.2"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M8.91797 3.7876C9.24047 5.8576 10.9205 7.4401 13.0055 7.6501"
                                    stroke="#FBBC05"
                                    stroke-width="1.2"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M2.25 16.5H15.75"
                                    stroke="#FBBC05"
                                    stroke-width="1.2"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>{" "}
                                Review (Send back for review)
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="#/action-3"
                                onClick={handleShow8}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                >
                                  <path
                                    d="M9 16.5C13.125 16.5 16.5 13.125 16.5 9C16.5 4.875 13.125 1.5 9 1.5C4.875 1.5 1.5 4.875 1.5 9C1.5 13.125 4.875 16.5 9 16.5Z"
                                    stroke="#FE0000"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M6.87793 11.1224L11.1229 6.87744"
                                    stroke="#FE0000"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M11.1229 11.1224L6.87793 6.87744"
                                    stroke="#FE0000"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>{" "}
                                Reject
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <button className="submitbutton">Submit</button>
                      </div>
                    </div>
                  </div>
                </Container>
              </Navbar>
            </div>
          ) : (
            <div className="main-navbar">
              <Navbar
                color={
                  props.location.pathname.indexOf("full-screen-maps") !== -1
                    ? ""
                    : color
                }
                expand="lg"
                className={
                  props.location.pathname.indexOf("full-screen-maps") !== -1
                    ? ""
                    : "" +
                      (color === "transparent" ? "navbar-transparent " : "")
                }
              >
                <Container fluid className="main-header-top-change p-0">
                  <div className="topnavbar d-none">
                    <div className="logo d-none mobile-show-logo">
                      <img src="\logo.svg" alt="img" className="img-fluid" />
                    </div>
                    <div className="navbar-wrapper">
                      <div className="navbar-toggle">
                        <button
                          type="button"
                          ref={sidebarToggle}
                          className="notificationbtn"
                          onClick={() => openSidebar()}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="23"
                            viewBox="0 0 22 23"
                            fill="none"
                          >
                            <path
                              d="M4.5835 16.0834H11.9168M4.5835 11.5H17.4168M10.0835 6.91669H17.4168"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          {/* <span className="navbar-toggler-bar bar1" />
             <span className="navbar-toggler-bar bar2" />
             <span className="navbar-toggler-bar bar3" /> */}
                        </button>
                      </div>
                      {/* <NavbarBrand href="/">{brandName}</NavbarBrand> */}
                    </div>
                  </div>
                  {/* <NavbarToggler onClick={toggle}>
         <span className="navbar-toggler-bar navbar-kebab" />
         <span className="navbar-toggler-bar navbar-kebab" />
         <span className="navbar-toggler-bar navbar-kebab" />
       </NavbarToggler> */}
                  <div className="innnernavbar">
                    <div className="navleft">
                      <p className="mainbrandnamepara">
                        {brandName}
                        {brandName === "Purchased NFTs" &&
                          `(${userDashboardStats?.nftCount})`}
                      </p>
                    </div>
                    <div className="navright">
                      <div className="inputdiv">
                        <input
                          type="text"
                          id="fname"
                          name="fname"
                          className="inputnavvv"
                          placeholder="Search "
                        />
                        {/* <img className='imgwhitesearch' src='\assets\Searchwhite.svg' alt='search' /> */}

                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          className="imgwhitesearch"
                        >
                          <path
                            d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z"
                            stroke="#7E7E7E"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M15.75 15.7498L12.4875 12.4873"
                            stroke="#7E7E7E"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      {account ? (
                        <>
                          <button
                            className="navcommonbtn"
                            onClick={logoutHandle}
                          >
                            Disconnect
                          </button>
                          <p>
                            {account
                              ? `${account?.slice(0, 6)}...${account?.slice(
                                  -4
                                )}`
                              : "N/A"}
                          </p>
                        </>
                      ) : (
                        <button className="navcommonbtn" onClick={handleShow}>
                          Connect Wallet
                        </button>
                      )}

                      <button className="whitebtn">
                        <div className="whitebtnimg">
                          <img
                            src={user ? user?.profileImage : null}
                            alt="btninnerimg"
                            className="btninnerimg"
                          />
                        </div>
                        <p className="btninnerpara">
                          {user
                            ? user.name
                              ? user?.name
                              : user?.email.split("@")[0]
                            : ""}
                        </p>
                      </button>
                    </div>
                  </div>
                </Container>
              </Navbar>
            </div>
          )}
        </>
      )}
      <Modal className="ambmodalmain" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Connect Your Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p className="connect">Please connect your crypto wallet.</p>
            <div className="meta lastmeta" onClick={() => connectMetaMask1()}>
              <div className="inermeta">
                <img src="\assets\dashboard\metamask.svg" />
                <p> Metamask</p>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M7 17L17 7M17 7H9M17 7V15"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div
              className="meta"
              onClick={() => {
                // handleShow1();
                handleClose();
                trustWallet();
              }}
            >
              <div className="inermeta">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                >
                  <path
                    d="M6.11994 9.12561C10.1953 4.95813 16.8047 4.95813 20.8801 9.12561L21.3701 9.62382C21.5765 9.83253 21.5765 10.1692 21.3701 10.3779L19.6936 12.0947C19.5904 12.1957 19.4292 12.1957 19.326 12.0947L18.649 11.4012C15.8053 8.49274 11.1947 8.49274 8.35105 11.4012L7.62884 12.1418C7.52566 12.2428 7.36446 12.2428 7.26128 12.1418L5.57828 10.4317C5.37194 10.223 5.37194 9.88639 5.57828 9.67768L6.11994 9.12561ZM24.3492 12.6737L25.8452 14.202C26.0516 14.4107 26.0516 14.7473 25.8452 14.956L19.1068 21.8435C18.9004 22.0522 18.5716 22.0522 18.3717 21.8435L13.5935 16.9556C13.5419 16.9017 13.4581 16.9017 13.4065 16.9556L8.62832 21.8435C8.42198 22.0522 8.09311 22.0522 7.89322 21.8435L1.15476 14.956C0.948414 14.7473 0.948414 14.4107 1.15476 14.202L2.65076 12.6737C2.85711 12.465 3.18597 12.465 3.38587 12.6737L8.16404 17.5615C8.21563 17.6154 8.29946 17.6154 8.35105 17.5615L13.1292 12.6737C13.3356 12.465 13.6644 12.465 13.8643 12.6737L18.6425 17.5615C18.6941 17.6154 18.7779 17.6154 18.8295 17.5615L23.6077 12.6737C23.814 12.465 24.1429 12.465 24.3492 12.6737Z"
                    fill="#007FFF"
                  />
                </svg>
                <p> Connect Wallet</p>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M7 17L17 7M17 7H9M17 7V15"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="ambmodalmain"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Connect Your Wallet
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12.0008 13.9008L7.10078 18.8008C6.91745 18.9841 6.68411 19.0758 6.40078 19.0758C6.11745 19.0758 5.88411 18.9841 5.70078 18.8008C5.51745 18.6174 5.42578 18.3841 5.42578 18.1008C5.42578 17.8174 5.51745 17.5841 5.70078 17.4008L10.6008 12.5008L5.70078 7.60078C5.51745 7.41745 5.42578 7.18411 5.42578 6.90078C5.42578 6.61745 5.51745 6.38411 5.70078 6.20078C5.88411 6.01745 6.11745 5.92578 6.40078 5.92578C6.68411 5.92578 6.91745 6.01745 7.10078 6.20078L12.0008 11.1008L16.9008 6.20078C17.0841 6.01745 17.3174 5.92578 17.6008 5.92578C17.8841 5.92578 18.1174 6.01745 18.3008 6.20078C18.4841 6.38411 18.5758 6.61745 18.5758 6.90078C18.5758 7.18411 18.4841 7.41745 18.3008 7.60078L13.4008 12.5008L18.3008 17.4008C18.4841 17.5841 18.5758 17.8174 18.5758 18.1008C18.5758 18.3841 18.4841 18.6174 18.3008 18.8008C18.1174 18.9841 17.8841 19.0758 17.6008 19.0758C17.3174 19.0758 17.0841 18.9841 16.9008 18.8008L12.0008 13.9008Z"
                fill="white"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="classmains">
            <div className="modal2">
              <p className="connect">
                Scan QR code with a WalletConnect-compatible wallet
              </p>
              <img src="\assets\dashboard\scann.svg" />
            </div>
            <div className="parentbuttonssss">
              <button className="okay">Copy to Clipboard</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="ambmodalmain1"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Success
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12.0008 13.9008L7.10078 18.8008C6.91745 18.9841 6.68411 19.0758 6.40078 19.0758C6.11745 19.0758 5.88411 18.9841 5.70078 18.8008C5.51745 18.6174 5.42578 18.3841 5.42578 18.1008C5.42578 17.8174 5.51745 17.5841 5.70078 17.4008L10.6008 12.5008L5.70078 7.60078C5.51745 7.41745 5.42578 7.18411 5.42578 6.90078C5.42578 6.61745 5.51745 6.38411 5.70078 6.20078C5.88411 6.01745 6.11745 5.92578 6.40078 5.92578C6.68411 5.92578 6.91745 6.01745 7.10078 6.20078L12.0008 11.1008L16.9008 6.20078C17.0841 6.01745 17.3174 5.92578 17.6008 5.92578C17.8841 5.92578 18.1174 6.01745 18.3008 6.20078C18.4841 6.38411 18.5758 6.61745 18.5758 6.90078C18.5758 7.18411 18.4841 7.41745 18.3008 7.60078L13.4008 12.5008L18.3008 17.4008C18.4841 17.5841 18.5758 17.8174 18.5758 18.1008C18.5758 18.3841 18.4841 18.6174 18.3008 18.8008C18.1174 18.9841 17.8841 19.0758 17.6008 19.0758C17.3174 19.0758 17.0841 18.9841 16.9008 18.8008L12.0008 13.9008Z"
                fill="white"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal2">
            <img src="\product\tickkk.svg" className="tickkimg" alt="img" />
            <p className="changespass">Product details edited successfully</p>
            <p className="approveddiv">
              We will update you once the submission has been approved.
            </p>
          </div>
          <div className="parentbuttons">
            <button
              className="okay"
              onClick={() => {
                handleClose2();
              }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="ambmodalmain1"
        show={show3}
        onHide={handleClose3}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Confirmation
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12.0008 13.9008L7.10078 18.8008C6.91745 18.9841 6.68411 19.0758 6.40078 19.0758C6.11745 19.0758 5.88411 18.9841 5.70078 18.8008C5.51745 18.6174 5.42578 18.3841 5.42578 18.1008C5.42578 17.8174 5.51745 17.5841 5.70078 17.4008L10.6008 12.5008L5.70078 7.60078C5.51745 7.41745 5.42578 7.18411 5.42578 6.90078C5.42578 6.61745 5.51745 6.38411 5.70078 6.20078C5.88411 6.01745 6.11745 5.92578 6.40078 5.92578C6.68411 5.92578 6.91745 6.01745 7.10078 6.20078L12.0008 11.1008L16.9008 6.20078C17.0841 6.01745 17.3174 5.92578 17.6008 5.92578C17.8841 5.92578 18.1174 6.01745 18.3008 6.20078C18.4841 6.38411 18.5758 6.61745 18.5758 6.90078C18.5758 7.18411 18.4841 7.41745 18.3008 7.60078L13.4008 12.5008L18.3008 17.4008C18.4841 17.5841 18.5758 17.8174 18.5758 18.1008C18.5758 18.3841 18.4841 18.6174 18.3008 18.8008C18.1174 18.9841 17.8841 19.0758 17.6008 19.0758C17.3174 19.0758 17.0841 18.9841 16.9008 18.8008L12.0008 13.9008Z"
                fill="white"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal2">
            <img src="\product\thumb.png" className="tickkimgddd" alt="img" />
            <p className="changespass">
              Are you sure you want to approve this product
            </p>
          </div>
          <div className="parentbuttons">
            <button
              className="cancelbutt"
              onClick={() => {
                handleClose3();
              }}
            >
              Cancel
            </button>
            <button
              className="okays"
              onClick={() => {
                handleShow4();
                handleClose3();
              }}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="ambmodalmain1"
        show={show4}
        onHide={handleClose4}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Success
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12.0008 13.9008L7.10078 18.8008C6.91745 18.9841 6.68411 19.0758 6.40078 19.0758C6.11745 19.0758 5.88411 18.9841 5.70078 18.8008C5.51745 18.6174 5.42578 18.3841 5.42578 18.1008C5.42578 17.8174 5.51745 17.5841 5.70078 17.4008L10.6008 12.5008L5.70078 7.60078C5.51745 7.41745 5.42578 7.18411 5.42578 6.90078C5.42578 6.61745 5.51745 6.38411 5.70078 6.20078C5.88411 6.01745 6.11745 5.92578 6.40078 5.92578C6.68411 5.92578 6.91745 6.01745 7.10078 6.20078L12.0008 11.1008L16.9008 6.20078C17.0841 6.01745 17.3174 5.92578 17.6008 5.92578C17.8841 5.92578 18.1174 6.01745 18.3008 6.20078C18.4841 6.38411 18.5758 6.61745 18.5758 6.90078C18.5758 7.18411 18.4841 7.41745 18.3008 7.60078L13.4008 12.5008L18.3008 17.4008C18.4841 17.5841 18.5758 17.8174 18.5758 18.1008C18.5758 18.3841 18.4841 18.6174 18.3008 18.8008C18.1174 18.9841 17.8841 19.0758 17.6008 19.0758C17.3174 19.0758 17.0841 18.9841 16.9008 18.8008L12.0008 13.9008Z"
                fill="white"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal2">
            <img src="\product\tickkk.svg" className="tickkimg" alt="img" />
            <p className="changespass">Product approved successfully</p>
          </div>
          <div className="parentbuttons">
            <button
              className="okay"
              onClick={() => {
                handleClose4();
              }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="ambmodalmain1"
        show={show5}
        onHide={handleClose5}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Confirmation
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12.0008 13.9008L7.10078 18.8008C6.91745 18.9841 6.68411 19.0758 6.40078 19.0758C6.11745 19.0758 5.88411 18.9841 5.70078 18.8008C5.51745 18.6174 5.42578 18.3841 5.42578 18.1008C5.42578 17.8174 5.51745 17.5841 5.70078 17.4008L10.6008 12.5008L5.70078 7.60078C5.51745 7.41745 5.42578 7.18411 5.42578 6.90078C5.42578 6.61745 5.51745 6.38411 5.70078 6.20078C5.88411 6.01745 6.11745 5.92578 6.40078 5.92578C6.68411 5.92578 6.91745 6.01745 7.10078 6.20078L12.0008 11.1008L16.9008 6.20078C17.0841 6.01745 17.3174 5.92578 17.6008 5.92578C17.8841 5.92578 18.1174 6.01745 18.3008 6.20078C18.4841 6.38411 18.5758 6.61745 18.5758 6.90078C18.5758 7.18411 18.4841 7.41745 18.3008 7.60078L13.4008 12.5008L18.3008 17.4008C18.4841 17.5841 18.5758 17.8174 18.5758 18.1008C18.5758 18.3841 18.4841 18.6174 18.3008 18.8008C18.1174 18.9841 17.8841 19.0758 17.6008 19.0758C17.3174 19.0758 17.0841 18.9841 16.9008 18.8008L12.0008 13.9008Z"
                fill="white"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal2">
            <img src="\product\pencil.svg" className="tickkimgddd" alt="img" />
            <p className="changespass">
              Are you sure you want to send back this product for review
            </p>
          </div>
          <div className="parentbuttons">
            <button
              className="cancelbutt"
              onClick={() => {
                handleClose5();
              }}
            >
              Cancel
            </button>
            <button
              className="okaysred"
              onClick={() => {
                handleShow6();
                handleClose5();
              }}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="ambmodalmain1"
        show={show6}
        onHide={handleClose6}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Comment
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12.0008 13.9008L7.10078 18.8008C6.91745 18.9841 6.68411 19.0758 6.40078 19.0758C6.11745 19.0758 5.88411 18.9841 5.70078 18.8008C5.51745 18.6174 5.42578 18.3841 5.42578 18.1008C5.42578 17.8174 5.51745 17.5841 5.70078 17.4008L10.6008 12.5008L5.70078 7.60078C5.51745 7.41745 5.42578 7.18411 5.42578 6.90078C5.42578 6.61745 5.51745 6.38411 5.70078 6.20078C5.88411 6.01745 6.11745 5.92578 6.40078 5.92578C6.68411 5.92578 6.91745 6.01745 7.10078 6.20078L12.0008 11.1008L16.9008 6.20078C17.0841 6.01745 17.3174 5.92578 17.6008 5.92578C17.8841 5.92578 18.1174 6.01745 18.3008 6.20078C18.4841 6.38411 18.5758 6.61745 18.5758 6.90078C18.5758 7.18411 18.4841 7.41745 18.3008 7.60078L13.4008 12.5008L18.3008 17.4008C18.4841 17.5841 18.5758 17.8174 18.5758 18.1008C18.5758 18.3841 18.4841 18.6174 18.3008 18.8008C18.1174 18.9841 17.8841 19.0758 17.6008 19.0758C17.3174 19.0758 17.0841 18.9841 16.9008 18.8008L12.0008 13.9008Z"
                fill="white"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p className="cmntptag">Comment</p>

            <textarea
              className="cmntinpuut"
              rows="4"
              cols="50"
              name="comment"
              form="usrform"
              placeholder="Write your comment..."
            ></textarea>
          </div>

          <div className="parentbuttons">
            <button
              className="cancelbutt"
              onClick={() => {
                handleClose6();
              }}
            >
              Cancel
            </button>
            <button
              className="okays"
              onClick={() => {
                handleShow7();
                handleClose6();
              }}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="ambmodalmain1"
        show={show7}
        onHide={handleClose7}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Success
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12.0008 13.9008L7.10078 18.8008C6.91745 18.9841 6.68411 19.0758 6.40078 19.0758C6.11745 19.0758 5.88411 18.9841 5.70078 18.8008C5.51745 18.6174 5.42578 18.3841 5.42578 18.1008C5.42578 17.8174 5.51745 17.5841 5.70078 17.4008L10.6008 12.5008L5.70078 7.60078C5.51745 7.41745 5.42578 7.18411 5.42578 6.90078C5.42578 6.61745 5.51745 6.38411 5.70078 6.20078C5.88411 6.01745 6.11745 5.92578 6.40078 5.92578C6.68411 5.92578 6.91745 6.01745 7.10078 6.20078L12.0008 11.1008L16.9008 6.20078C17.0841 6.01745 17.3174 5.92578 17.6008 5.92578C17.8841 5.92578 18.1174 6.01745 18.3008 6.20078C18.4841 6.38411 18.5758 6.61745 18.5758 6.90078C18.5758 7.18411 18.4841 7.41745 18.3008 7.60078L13.4008 12.5008L18.3008 17.4008C18.4841 17.5841 18.5758 17.8174 18.5758 18.1008C18.5758 18.3841 18.4841 18.6174 18.3008 18.8008C18.1174 18.9841 17.8841 19.0758 17.6008 19.0758C17.3174 19.0758 17.0841 18.9841 16.9008 18.8008L12.0008 13.9008Z"
                fill="white"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal2">
            <img src="\product\tickkk.svg" className="tickkimg" alt="img" />
            <p className="changespass">
              Product sent back for review successfully
            </p>
          </div>
          <div className="parentbuttons">
            <button
              className="okay"
              onClick={() => {
                handleClose7();
              }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="ambmodalmain1"
        show={show8}
        onHide={handleClose8}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Confirmation
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12.0008 13.9008L7.10078 18.8008C6.91745 18.9841 6.68411 19.0758 6.40078 19.0758C6.11745 19.0758 5.88411 18.9841 5.70078 18.8008C5.51745 18.6174 5.42578 18.3841 5.42578 18.1008C5.42578 17.8174 5.51745 17.5841 5.70078 17.4008L10.6008 12.5008L5.70078 7.60078C5.51745 7.41745 5.42578 7.18411 5.42578 6.90078C5.42578 6.61745 5.51745 6.38411 5.70078 6.20078C5.88411 6.01745 6.11745 5.92578 6.40078 5.92578C6.68411 5.92578 6.91745 6.01745 7.10078 6.20078L12.0008 11.1008L16.9008 6.20078C17.0841 6.01745 17.3174 5.92578 17.6008 5.92578C17.8841 5.92578 18.1174 6.01745 18.3008 6.20078C18.4841 6.38411 18.5758 6.61745 18.5758 6.90078C18.5758 7.18411 18.4841 7.41745 18.3008 7.60078L13.4008 12.5008L18.3008 17.4008C18.4841 17.5841 18.5758 17.8174 18.5758 18.1008C18.5758 18.3841 18.4841 18.6174 18.3008 18.8008C18.1174 18.9841 17.8841 19.0758 17.6008 19.0758C17.3174 19.0758 17.0841 18.9841 16.9008 18.8008L12.0008 13.9008Z"
                fill="white"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal2">
            <img src="\product\reject.svg" className="tickkimgddd" alt="img" />
            <p className="changespass">
              Are you sure you want to reject this product
            </p>
          </div>
          <div className="parentbuttons">
            <button
              className="cancelbutt"
              onClick={() => {
                handleClose8();
              }}
            >
              Cancel
            </button>
            <button
              className="okaysred"
              onClick={() => {
                handleShow9();
                handleClose8();
              }}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="ambmodalmain1"
        show={show9}
        onHide={handleClose9}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Comment
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12.0008 13.9008L7.10078 18.8008C6.91745 18.9841 6.68411 19.0758 6.40078 19.0758C6.11745 19.0758 5.88411 18.9841 5.70078 18.8008C5.51745 18.6174 5.42578 18.3841 5.42578 18.1008C5.42578 17.8174 5.51745 17.5841 5.70078 17.4008L10.6008 12.5008L5.70078 7.60078C5.51745 7.41745 5.42578 7.18411 5.42578 6.90078C5.42578 6.61745 5.51745 6.38411 5.70078 6.20078C5.88411 6.01745 6.11745 5.92578 6.40078 5.92578C6.68411 5.92578 6.91745 6.01745 7.10078 6.20078L12.0008 11.1008L16.9008 6.20078C17.0841 6.01745 17.3174 5.92578 17.6008 5.92578C17.8841 5.92578 18.1174 6.01745 18.3008 6.20078C18.4841 6.38411 18.5758 6.61745 18.5758 6.90078C18.5758 7.18411 18.4841 7.41745 18.3008 7.60078L13.4008 12.5008L18.3008 17.4008C18.4841 17.5841 18.5758 17.8174 18.5758 18.1008C18.5758 18.3841 18.4841 18.6174 18.3008 18.8008C18.1174 18.9841 17.8841 19.0758 17.6008 19.0758C17.3174 19.0758 17.0841 18.9841 16.9008 18.8008L12.0008 13.9008Z"
                fill="white"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p className="cmntptag">Comment</p>

            <textarea
              className="cmntinpuut"
              rows="4"
              cols="50"
              name="comment"
              form="usrform"
              placeholder="Write your comment..."
            ></textarea>
          </div>

          <div className="parentbuttons">
            <button
              className="cancelbutt"
              onClick={() => {
                handleClose9();
              }}
            >
              Cancel
            </button>
            <button
              className="okays"
              onClick={() => {
                handleShow10();
                handleClose9();
              }}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="ambmodalmain1"
        show={show10}
        onHide={handleClose10}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Success
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12.0008 13.9008L7.10078 18.8008C6.91745 18.9841 6.68411 19.0758 6.40078 19.0758C6.11745 19.0758 5.88411 18.9841 5.70078 18.8008C5.51745 18.6174 5.42578 18.3841 5.42578 18.1008C5.42578 17.8174 5.51745 17.5841 5.70078 17.4008L10.6008 12.5008L5.70078 7.60078C5.51745 7.41745 5.42578 7.18411 5.42578 6.90078C5.42578 6.61745 5.51745 6.38411 5.70078 6.20078C5.88411 6.01745 6.11745 5.92578 6.40078 5.92578C6.68411 5.92578 6.91745 6.01745 7.10078 6.20078L12.0008 11.1008L16.9008 6.20078C17.0841 6.01745 17.3174 5.92578 17.6008 5.92578C17.8841 5.92578 18.1174 6.01745 18.3008 6.20078C18.4841 6.38411 18.5758 6.61745 18.5758 6.90078C18.5758 7.18411 18.4841 7.41745 18.3008 7.60078L13.4008 12.5008L18.3008 17.4008C18.4841 17.5841 18.5758 17.8174 18.5758 18.1008C18.5758 18.3841 18.4841 18.6174 18.3008 18.8008C18.1174 18.9841 17.8841 19.0758 17.6008 19.0758C17.3174 19.0758 17.0841 18.9841 16.9008 18.8008L12.0008 13.9008Z"
                fill="white"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal2">
            <img src="\product\tickkk.svg" className="tickkimg" alt="img" />
            <p className="changespass">Product rejected successfully</p>
          </div>
          <div className="parentbuttons">
            <button
              className="okay"
              onClick={() => {
                handleClose10();
              }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Header;
